import { AlkEvent, ChronocodeTemplateVO, ChronocodeVO } from '@wizeoo/akm-common-lib';
import { ChronoLevelCreationGroup } from './chrono-level-creation.group';
import { TimeGapVO } from '@wizeoo/akm-common-lib';
import { ViewData } from '@wizeoo/akm-common-lib';
import { TIME_UNIT, ALK_EVENT_TYPE } from '@wizeoo/akm-common-lib';
import { Model } from './../../../model/model';
import { WIZ_EVENT_TYPE, WizDateUtils, CONFIRMATION_MODE, CONFIRMATION_RESULT } from '@wizeoo/akm-core-lib';
import {
  WizTextInput,
  WizDropdown,
  WizDateField,
  WizDatasource,
  WizTranslationInput,
  WizButton,
  WizValidatorFn,
  WizValidationErrors,
  WizValidationError,
  WizValidationContainerDirective,
  WizPopUp,
  ConfirmationResultObj,
  WizFocusManager,
  WizTree,
  WizEventManager, WizEvent
} from '@wizeoo/akm-component-lib';
import { Component, ViewChild, ViewChildren, QueryList, HostBinding } from '@angular/core';
import { BaseView } from '@wizeoo/akm-common-lib';
import { ChronocodeTreeRenderer } from '../renderer/edit/chronocode.tree.renderer';
import { ChronocodeGenerator } from '@wizeoo/akm-common-lib';
import { RouteEngine } from 'src/app/manager/routing/route.engine';

/**
 * Vue de creation d'arbre de chronocodes
 * Author : SVA
 */
@Component({
  selector: 'chronocode-creation-view',
  templateUrl: './chronocode-creation.view.html',
})
export class ChronocodeCreationView extends BaseView {
  @HostBinding('style.padding') forcedNoPadding = 'padding: 0px !important'; // c'est une vue enfant
  
  
  /** Zone de validation des champs de saisie */
  @ViewChild('hgCodeLabel', { read: WizValidationContainerDirective, static: false })
  private hgCodeLabelContainer: WizValidationContainerDirective;
  @ViewChild('hgTimeGap', { read: WizValidationContainerDirective, static: false })
  private hgTimeGapContainer: WizValidationContainerDirective;
  @ViewChild('hgDates', { read: WizValidationContainerDirective, static: false })
  private hgDatesContainer: WizValidationContainerDirective;

  /** Input de saisie label */
  @ViewChild('tiHeaderLabel', { read: WizTranslationInput, static: false }) tiHeaderLabel: WizTranslationInput;
  /** Input de saisie shortcode */
  @ViewChild('tiHeaderShortCode', { read: WizTextInput, static: false }) tiHeaderShortCode: WizTextInput;
  /** Dropdown de saisie de durée */
  @ViewChild('ddlHeaderTimeGap', { read: WizDropdown, static: false }) ddlHeaderTimeGap: WizDropdown;
  /** datefield de date de début */
  @ViewChild('dfHeaderStartDate', { read: WizDateField, static: false }) dfHeaderStartDate: WizDateField;
  /** datefield de date de fin */
  @ViewChild('dfHeaderEndDate', { read: WizDateField, static: false }) dfHeaderEndDate: WizDateField;

  /** bouton de creation */
  @ViewChild('btCreateChronocode', { read: WizButton, static: false }) btCreateChronocode: WizButton;
  /** bouton cancel */
  @ViewChild('btnCancel', { read: WizButton }) private btnCancel: WizButton;
  @ViewChild('btnNewLevel', { read: WizButton, static: false }) btnNewLevel: WizButton; // ajout de level

  @ViewChild('sampleTree', { read: WizTree, static: false }) sampleTree: WizTree<ChronocodeVO>;

  /** Enfants editions de niveau */
  @ViewChildren(ChronoLevelCreationGroup) levelChildren: QueryList<ChronoLevelCreationGroup>;

  public template: ChronocodeTemplateVO = null; /** Template en cours d'édition, porté par engine. Pour accès rapide */
  public canAddSubLevel: boolean = true; /** flag indiquant si un nouveau niveau peut être ajouté */

  /** Datasource de la liste de timegaps  pour les enfants */
  public timegapDS: WizDatasource<TimeGapVO> = new WizDatasource<TimeGapVO>([])
    .setSortFields([{ property: 'temporalWeightSort', way: 'desc', numeric: true }])
    .setSelectionMode('single')
    .build();

  public sampleRenderer: any = ChronocodeTreeRenderer; // rendu du tree sample

  /** Data source de l'arbre de samples */
  public sampleDS: WizDatasource<ChronocodeVO> = new WizDatasource<ChronocodeVO>([])
    .setHierarchical(true)
    .setItemCodeField('code')
    .setItemParentCodeField('subTreeParentCode')
    .setSortFields([{ property: 'startDate', way: 'asc', numeric: true }])
    .setSelectionMode('none')
    .build();

  /* ################################################
                      cycle de vie
   ################################################ */

  /** Synchronisation des données du template sélectionné (ou initié) */
  public wizSynchronizeData(): void {
    this.tiHeaderShortCode.wizRestrict = ViewData.CODE_REGEXP;
    this.timegapDS.setSource(Model.getInstance().timegapList);
    this.sampleTree.wizDataProvider = this.sampleDS;
    this.sampleTree.actionsRenderer = this.sampleRenderer;
    this.feed();
    this.focusFormFields();
  }

  /**
   * Pose listeners
   */
  public wizAddListener(): void {
    WizEventManager.addListener(this, this.elementRef, WIZ_EVENT_TYPE.MODEL_UPDATE, this.onHeaderChange);
    WizEventManager.addListener(this, this.btnCancel, WIZ_EVENT_TYPE.CLICK, this.cancelEdition);
    WizEventManager.addListener(this, this.btCreateChronocode, WIZ_EVENT_TYPE.CLICK, this.create);

    WizEventManager.addListener(this, this.elementRef, ALK_EVENT_TYPE.CHRONO_LEVEL_ACTIVATE, this.onLevelActivation);
    WizEventManager.addListener(
      this,
      this.elementRef,
      ALK_EVENT_TYPE.CHRONO_LEVEL_DEACTIVATE,
      this.onLevelDeactivation
    );

    WizEventManager.addListener(
      this,
      this.ddlHeaderTimeGap,
      WIZ_EVENT_TYPE.SELECTION_CHANGING,
      this.askForChangeTimeGapCode,
      { capture: true }
    );
    WizEventManager.addListener(this, this.btnNewLevel, WIZ_EVENT_TYPE.CLICK, this.askForLevel2);
  }

  /**
   * Destruction listeners
   */
  public wizRemoveListener(): void {
    WizEventManager.removeListener(this, this.elementRef, WIZ_EVENT_TYPE.MODEL_UPDATE);
    WizEventManager.removeListener(this, this.btCreateChronocode, WIZ_EVENT_TYPE.CLICK);
    WizEventManager.removeListener(this, this.btnCancel, WIZ_EVENT_TYPE.CLICK);
    WizEventManager.removeListener(this, this.elementRef, ALK_EVENT_TYPE.CHRONO_LEVEL_ACTIVATE);
    WizEventManager.removeListener(this, this.elementRef, ALK_EVENT_TYPE.CHRONO_LEVEL_DEACTIVATE);

    WizEventManager.removeListener(this, this.ddlHeaderTimeGap, WIZ_EVENT_TYPE.SELECTION_CHANGING);
    WizEventManager.removeListener(this, this.btnNewLevel, WIZ_EVENT_TYPE.CLICK);
  }

  /** Alimentation  des données du template sélectionné (ou initié) dans la vue */
  private feed(): void {
    this.template = Model.getInstance().chronoCodeTemplate;
    if (!!this.template) {
      // accès direct sans sélection de chrono
      this.tiHeaderShortCode.wizValue = this.template.shortCode;
      this.tiHeaderLabel.translationData = Model.getInstance().localeEngine.buildTranslationData(this.template.labelVO);
      this.timegapDS.select([this.template.timeGapVO]);
      this.dfHeaderStartDate.wizNumberValue = this.template.startDate;
      this.dfHeaderEndDate.wizNumberValue = this.template.endDate;
      this.manageComponents();
    } else {
      Model.getInstance().navigationEngine.navigate(RouteEngine.CHRONO_VIEW);
    }
  }

  /**
   * Gestion d'accessibilité des composants
   */
  private manageComponents(): void {
    this.dfHeaderStartDate.wizDisabled = this.template.hasChild;
    this.dfHeaderEndDate.wizDisabled = this.template.timeGapCode !== TIME_UNIT.UNDEFINED || this.template.hasChild; // sur undefined, fin manuelle
    this.dfHeaderEndDate.wizMinDate = this.dfHeaderStartDate.wizDateValue; // date de fin min = startDate
    this.dfHeaderStartDate.wizMaxDate =
      this.template.timeGapCode === TIME_UNIT.UNDEFINED ? this.dfHeaderEndDate.wizDateValue : null; // date de début < fin

    if (ViewData.wizUpdateModel) {
      // save actif si modelUpdate = true
      this.btCreateChronocode.wizDisabled = false;
      this.btnCancel.wizDisabled = false;
    } else {
      this.btCreateChronocode.wizDisabled = true;
      this.btnCancel.wizDisabled = true;
    }

    this.canAddSubLevel = this.template.timeGapCode !== TIME_UNIT.DAY && this.template.subLevels.length <= 0;
  }

  /** focus du premier champs actif */
  public focusFormFields(): void {
    WizFocusManager.getInstance().wizSetFocus(this.tiHeaderShortCode);
  }

  /* ################################################
                 interactions
   ################################################ */

  /**
   * Modification dans le header (chronocode lvl 1)
   * @param e Evenement model change
   */
  private onHeaderChange(e: WizEvent): void {
    switch (e.component) {
      case this.tiHeaderShortCode:
        this.template.shortCode = this.tiHeaderShortCode.wizValue?.toUpperCase();
        break;
      case this.tiHeaderLabel:
        this.template.labelVO.updateTranslationEntry(e.value);
        break;
      case this.ddlHeaderTimeGap:
        this.template.timeGapCode = this.ddlHeaderTimeGap.selectedItem.code;
        this.onTimeGapChanged();
        break;
      case this.dfHeaderStartDate:
        this.template.startDate = this.dfHeaderStartDate.wizNumberValue;
        this.onStartDateChanged();
        break;
      case this.dfHeaderEndDate:
        this.template.endDate = this.dfHeaderEndDate.wizNumberValue;
        break;
    }
    this.manageComponents();
    WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.UPDATE_MODEL, true));
  }

  /** Changement de timegap, on va tout écraser... Confirmation d'abord  */
  private askForChangeTimeGapCode(e: WizEvent): void {
    const vo: TimeGapVO = e.value[0];
    if (this.template.subLevels.length > 0) {
      e.preventDefault();
      WizPopUp.confirm(
        '$.common.pending.update.title.$',
        '$.chronocode.creation.level.cancelled.$',
        this.doChangeTimeGapCode.bind(this),
        CONFIRMATION_MODE.CONFIRM_CANCEL,
        vo,
        null,
        null
      ).show();
    }
  }

  /**
   * Changement de timegap
   * @param result confirmation de changement
   */
  private doChangeTimeGapCode(result: ConfirmationResultObj): void {
    if (result.result === CONFIRMATION_RESULT.CONFIRM) {
      this.template.subLevels = []; // on écrase les niveaux inférieurs
      this.template.timeGapCode = result.data.code;
      this.timegapDS.select([result.data]);

      this.onTimeGapChanged();
      this.filterStartDate();
      this.manageComponents();
      WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.UPDATE_MODEL, true));
    }
  }

  /** Sur changement de Timegap, tentative d'initialisation des dates */
  private onTimeGapChanged(): void {
    if (this.template.timeGapVO.calendar) {
      const startDate: Date = Model.getInstance().chronocodeEngine.getNextValidStartDate(this.template.timeGapVO);
      this.template.startDate = WizDateUtils.dateToNumber(startDate);
    } else {
      this.template.endDate = NaN;
    }
    this.dfHeaderStartDate.wizNumberValue = this.template.startDate;
    this.dfHeaderEndDate.wizNumberValue = this.template.endDate;

    this.onStartDateChanged();
  }

  /** Filtre des données accessibles sur la start date selon le timegap */
  private filterStartDate(): void {
    if (this.template.timeGapVO && this.template.timeGapVO.calendar) {
      switch (this.template.timeGapVO.unit) {
        case TIME_UNIT.YEAR:
          this.dfHeaderStartDate.wizDateMode = WizDateUtils.YEAR_MODE;
          this.dfHeaderStartDate.wizSelectableDays = [];
          break;
        case TIME_UNIT.MONTH:
          this.dfHeaderStartDate.wizDateMode = WizDateUtils.MONTH_MODE;
          this.dfHeaderStartDate.wizSelectableDays = [];
          break;
        case TIME_UNIT.WEEK:
          this.dfHeaderStartDate.wizDateMode = WizDateUtils.DATE_MODE;
          // Que les 1ers jours de la semaine
          this.dfHeaderStartDate.wizSelectableDays = [Model.getInstance().businessUnitEngine.currentBU.firstDayOfWeek];
          break;
        default:
          this.dfHeaderStartDate.wizDateMode = WizDateUtils.DATE_MODE;
          this.dfHeaderStartDate.wizSelectableDays = [];
          break;
      }
    } else {
      this.dfHeaderStartDate.wizDateMode = WizDateUtils.DATE_MODE;
      this.dfHeaderStartDate.wizSelectableDays = [];
    }
  }

  /** Sur changement de date de début, calcul de la date de fin si temps défini */
  private onStartDateChanged(): void {
    if (this.template.timeGapCode !== TIME_UNIT.UNDEFINED) {
      this.template.endDate = WizDateUtils.dateToNumber(
        Model.getInstance().chronocodeEngine.computeEndDate(WizDateUtils.numberToDate(this.template.startDate), this.template.timeGapVO)
      );
      this.dfHeaderEndDate.wizNumberValue = this.template.endDate;
    }
  }

  /* ################################################
              régénération des sous-niveaux
   ################################################ */

  /** Rafraichissement graphique des blocs d'édtion des niveaux */
  public refreshLevels(): void {
    this.levelChildren.forEach((levelGroup) => {
      levelGroup.refresh();
    });
  }

  /* ################################################
              régénération des sous-niveaux
   ################################################ */

  /**
   * Demande d'ajout du niveau 2
   * @param e wizEvent
   */
  private askForLevel2(e: WizEvent): void {
    // on calcule le poids sur le mainTemplate (pour alimentation undefined undefined)
    const startDate = WizDateUtils.numberToDate(this.template.startDate);
    const endDate = WizDateUtils.numberToDate(this.template.endDate);
    this.template.maxTimeWeight = WizDateUtils.dayDiff(startDate, endDate);

    this.template.addSubLevel();
    this.refreshLevels(); // refresh des groupes
    this.manageComponents();
  }

  /**
   * Activiation d'un niveau (Saisie d'un type de découpage)
   * dispatch depuis les creation_group
   */
  private onLevelActivation(e: AlkEvent): void {
    this.template.addSubLevel();
  }

  /** suppression d'un niveau, depuis les creation_group */
  private onLevelDeactivation(e: AlkEvent): void {
    this.template.removeSubLevel(e.data as number);
    // TODO reconstruire le sample s'il existe
    this.manageComponents();
    this.refreshLevels(); // refresh des sous-levels restants
  }

  /** génération du sample du chronocode */
  public generatePeriods(): void {
    // console.log('gen periods', this.template);
    const chronocodes: ChronocodeVO[] = ChronocodeGenerator.generateChronocode(Model.getInstance());
    this.sampleDS.setSource(chronocodes);
    this.sampleDS.expandAll();
  }

  /**
   * Validation du calendrier en cours de création
   * Génération de l'ensemble du chronocode & save
   * @param e : Evenement clic
   */
  private create(e: WizEvent): void {
    // Vérification de la saisie
    let errors = this.hgCodeLabelContainer.check(true, true, null, 1);
    errors = errors.concat(this.hgTimeGapContainer.check(true, true, null, 1));
    errors = errors.concat(this.hgDatesContainer.check(true, true, null, 1));
    this.levelChildren.forEach((group) => {
      errors = errors.concat(group.validationCheck());
    });
    if (errors && errors.length === 0) {
      const chronocodes: ChronocodeVO[] = ChronocodeGenerator.generateChronocode(Model.getInstance());
      Model.getInstance().chronocodeEngine.save(chronocodes, this.backFromCreationList.bind(this));
    }
  }

  /**
   * Retour de service merge list
   * @param bddBack chronocode retourné
   */
  private backFromCreationList(parent: ChronocodeVO): void {
    const creationEvent: AlkEvent = new AlkEvent(
      ALK_EVENT_TYPE.CHRONO_CREATE,
      Model.getInstance().chronocodeEngine.getChronocode(this.template.shortCode)
    );
    WizEventManager.dispatchEvent(this.elementRef, creationEvent);
  }

  /* #####################################
          VALIDATION DE SAISIE
     ##################################### */

  /**
   * flag indiquant si le bouton de création d'un sous niveau est actif
   * condition
   * - le timegap est renseigné
   * - la date de début est renseigné et valid
   * - la date de fin est renseigné et valid
   * @returns boolean, true si le
   */
  public canGenerate(): boolean {
    return !!this.template && this.template.mainChronoIsValid();
  }

  /** Validateur d'unicité du code principal */
  public uniqueCodeValidator(): WizValidatorFn {
    return (): WizValidationErrors | null => {
      // Pas de gestion d'erreur si le currentChronocode est null
      if (this.template === null || this.template === undefined) {
        return null;
      }
      if (
        this.tiHeaderShortCode.wizValue !== null &&
        this.tiHeaderShortCode.wizValue &&
        this.tiHeaderShortCode.wizValue.length > 0
      ) {
        // Recherche d'un autre pays avec le même code
        const otherChronocode = Model.getInstance().chronocodeEngine.getChronocode(this.tiHeaderShortCode.wizValue.toUpperCase());

        // Si un chro existe deja avec le meme code on affiche le message
        if (otherChronocode) {
          const temp: WizValidationError = {
            wizError: '$.chronocode.error.code.unique.$',
            wizErrorParams: [],
          };
          return [temp];
        }
      }
      return null;
    };
  }

  /**
   * click sur le bouton cancel
   * @param event, wizClick
   */
  private cancelEdition(): void {
    // s'il y a une modification de model en cours
    if (ViewData.wizUpdateModel) {
      // affichage de la popup d'information de changement en cours
      WizPopUp.confirm(
        '$.common.pending.update.title.$',
        '$.common.pending.update.detail.$',
        this.confirmCancel.bind(this),
        CONFIRMATION_MODE.YES_NO
      ).show();
    }
  }

  /**
   * Callback de la  WizPopupConfirmation déclenchée au cancel avec une modification du formulaire en cours
   * @param confirmationResult: Objet WizPopupConfirmationResultObj contenant le choix effectué sur la popup
   */
  private confirmCancel(confirmationResult: ConfirmationResultObj): void {
    if (confirmationResult.result === CONFIRMATION_RESULT.YES) {
      WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.UPDATE_MODEL, false));
      Model.getInstance().navigationEngine.navigate(RouteEngine.CHRONO_VIEW);
    }
  }
}
